<section class="sc" #ctaRoot aria-labelledby="sc-title">
  <div class="rs-shell">
    <div class="sc__panel">
      <!-- gradient mesh, blobs and drifting particles -->
      <span class="sc__mesh" aria-hidden="true"></span>
      <span class="sc__blob sc__blob--1" aria-hidden="true"></span>
      <span class="sc__blob sc__blob--2" aria-hidden="true"></span>
      <span class="sc__particle" style="--x: 12%; --y: 24%" aria-hidden="true"></span>
      <span class="sc__particle" style="--x: 30%; --y: 74%" aria-hidden="true"></span>
      <span class="sc__particle" style="--x: 62%; --y: 18%" aria-hidden="true"></span>
      <span class="sc__particle" style="--x: 86%; --y: 62%" aria-hidden="true"></span>
      <span class="sc__particle" style="--x: 74%; --y: 88%" aria-hidden="true"></span>

      <div class="sc__inner">
        <span class="sc__ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M6.5 3.5h3l1.5 4-2 1.4a11 11 0 006.1 6.1l1.4-2 4 1.5v3a2 2 0 01-2.2 2A16.5 16.5 0 014.5 5.7 2 2 0 016.5 3.5z"
              stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>

        <div class="sc__copy">
          <span class="sc__eyebrow">Let's Build Something Amazing</span>
          <h2 class="sc__title" id="sc-title">
            Connect With Our <span class="sc__grad">Business Experts</span>
          </h2>
          <p class="sc__text">
            Whether you're building a website, mobile application, enterprise software, or
            an AI solution, our experts are ready to help transform your ideas into reality.
          </p>
        </div>

        <div class="sc__actions">
          <a routerLink="/call-back" class="rs-btn rs-btn--primary sc__magnet" rsRipple>
            <span class="sc__btn-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M6.5 3.5h3l1.5 4-2 1.4a11 11 0 006.1 6.1l1.4-2 4 1.5v3a2 2 0 01-2.2 2A16.5 16.5 0 014.5 5.7 2 2 0 016.5 3.5z"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <span>Request a call back</span>
          </a>

          <a routerLink="/our-portfolio" class="rs-btn rs-btn--ghost sc__magnet">
            <span>View Portfolio</span>
            <span class="rs-btn__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
